import { createSlice } from "@reduxjs/toolkit";

const aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState: {
    vision: {
      data: [],
      loading: false,
      error: null,
    },
    leadershipMessages: {
      data: [],
      loading: false,
      error: null,
    },
    councilMember: {
      data: [],
      loading: false,
      error: null,
    },
    boardMember: {
      data: [],
      loading: false,
      error: null,
    },
    studiesMember: {
      data: [],
      loading: false,
      error: null,
    },
    history: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    // Vision Reducers
    fetchVisionStart(state) {
      state.vision.loading = true;
      state.vision.error = null;
    },
    fetchVisionSuccess(state, action) {
      state.vision.loading = false;
      state.vision.data = action.payload;
    },
    fetchVisionFailure(state, action) {
      state.vision.loading = false;
      state.vision.error = action.payload;
    },
    
    // Leadership Messages Reducers
    fetchLeadershipMessagesStart(state) {
      state.leadershipMessages.loading = true;
      state.leadershipMessages.error = null;
    },
    fetchLeadershipMessagesSuccess(state, action) {
      state.leadershipMessages.loading = false;
      state.leadershipMessages.data = action.payload;
    },
    fetchLeadershipMessagesFailure(state, action) {
      state.leadershipMessages.loading = false;
      state.leadershipMessages.error = action.payload;
    },
    // updateLeadershipMessage(state, action) {
    //   const updatedMessage = action.payload;
    //   const index = state.leadershipMessages.data.findIndex(
    //     (msg) => msg.id === updatedMessage.id
    //   );
    //   if (index !== -1) {
    //     state.leadershipMessages.data[index] = updatedMessage;
    //   }
    // },
    // deleteLeadershipMessage(state, action) {
    //   state.leadershipMessages.data = state.leadershipMessages.data.filter(
    //     (msg) => msg.id !== action.payload
    //   );
    // },

    updateLeadershipMessage(state, action) {
      const updatedMessage = action.payload;
      if (!updatedMessage?.id) {
        console.error("Updated message does not have an ID:", updatedMessage);
        return;
      }
      const index = state.leadershipMessages.data.findIndex(
        (msg) => msg.id === updatedMessage.id
      );
      if (index !== -1) {
        state.leadershipMessages.data[index] = updatedMessage;
      } else {
        console.warn("No matching message found for ID:", updatedMessage.id);
      }
    },
    
    addLeadershipMessageStart(state) {
      state.leadershipMessages.loading = true;
      state.leadershipMessages.error = null;
    },
    addLeadershipMessageSuccess(state, action) {
      state.leadershipMessages.loading = false;
      state.leadershipMessages.data.push(action.payload);
    },
    addLeadershipMessageFailure(state, action) {
      state.leadershipMessages.loading = false;
      state.leadershipMessages.error = action.payload;
    },
    addCouncilMemberStart(state) {
      state.councilMember.loading = true;
      state.councilMember.error = null;
    },
    addCouncilMemberSuccess(state, action) {
      state.councilMember.loading = false;
      state.councilMember.data.push(action.payload);
    },
    addCouncilMemberFailure(state, action) {
      state.councilMember.loading = false;
      state.councilMember.error = action.payload;
    },
    fetchCouncilMemberStart(state) {
      state.councilMember.loading = true;
      state.councilMember.error = null;
    },
    fetchCouncilMemberSuccess(state, action) {
      state.councilMember.loading = false;
      state.councilMember.data = action.payload;
    },
    fetchCouncilMemberFailure(state, action) {
      state.councilMember.loading = false;
      state.councilMember.error = action.payload;
    },
    updateCouncilMemberStart(state) {
      state.councilMember.loading = true;
      state.councilMember.error = null;
    },
    // updateCouncilMemberSuccess(state, action) {
    //   state.councilMember.loading = false;
    //   const updatedMember = action.payload;
    //   const index = state.councilMember.data.findIndex(
    //     (member) => member.id === updatedMember.id
    //   );
    //   if (index !== -1) {
    //     state.councilMember.data[index] = updatedMember;
    //   }
    // },
    updateCouncilMemberSuccess(state, action) {
      const updatedMember = action.payload;
      if (!updatedMember?.id) {
        console.error("Updated member does not have an ID:", updatedMember);
        return;
      }
      const index = state.councilMember.data.findIndex(
        (msg) => msg.id === updatedMember.id
      );
      if (index !== -1) {
        state.councilMember.data[index] = updatedMember;
      } else {
        console.warn("No matching member found for ID:", updatedMember.id);
      }
    },
    updateCouncilMemberFailure(state, action) {
      state.councilMember.loading = false;
      state.councilMember.error = action.payload;
    },
 
    addBoardMemberStart(state) {
      state.boardMember.loading = true;
      state.boardMember.error = null;
    },
    addBoardMemberSuccess(state, action) {
      state.boardMember.loading = false;
      state.boardMember.data.push(action.payload);
    },
    addBoardMemberFailure(state, action) {
      state.boardMember.loading = false;
      state.boardMember.error = action.payload;
    },
    fetchBoardMemberStart(state) {
      state.boardMember.loading = true;
      state.boardMember.error = null;
    },
    fetchBoardMemberSuccess(state, action) {
      state.boardMember.loading = false;
      state.boardMember.data = action.payload;
    },
    fetchBoardMemberFailure(state, action) {
      state.boardMember.loading = false;
      state.boardMember.error = action.payload;
    },
    updateBoardMemberStart(state) {
      state.boardMember.loading = true;
      state.boardMember.error = null;
    },
    // updateBoardMemberSuccess(state, action) {
    //   state.boardMember.loading = false;
    //   const updatedMember = action.payload;
    //   const index = state.boardMember.data.findIndex(
    //     (member) => member.id === updatedMember.id
    //   );
    //   if (index !== -1) {
    //     state.boardMember.data[index] = updatedMember;
    //   }
    // },
    updateBoardMemberSuccess(state, action) {
      const updatedMember = action.payload;
      if (!updatedMember?.id) {
        console.error("Updated member does not have an ID:", updatedMember);
        return;
      }
      const index = state.boardMember.data.findIndex(
        (msg) => msg.id === updatedMember.id
      );
      if (index !== -1) {
        state.boardMember.data[index] = updatedMember;
      } else {
        console.warn("No matching member found for ID:", updatedMember.id);
      }
    },
    updateBoardMemberFailure(state, action) {
      state.boardMember.loading = false;
      state.boardMember.error = action.payload;
    },
 
    addStudiesMemberStart(state) {
      state.studiesMember.loading = true;
      state.studiesMember.error = null;
    },
    addStudiesMemberSuccess(state, action) {
      state.studiesMember.loading = false;
      state.studiesMember.data.push(action.payload);
    },
    addStudiesMemberFailure(state, action) {
      state.studiesMember.loading = false;
      state.studiesMember.error = action.payload;
    },
    fetchStudiesMemberStart(state) {
      state.studiesMember.loading = true;
      state.studiesMember.error = null;
    },
    fetchStudiesMemberSuccess(state, action) {
      state.studiesMember.loading = false;
      state.studiesMember.data = action.payload;
    },
    fetchStudiesMemberFailure(state, action) {
      state.studiesMember.loading = false;
      state.studiesMember.error = action.payload;
    },
    updateStudiesMemberStart(state) {
      state.studiesMember.loading = true;
      state.studiesMember.error = null;
    },
    // updateStudiesMemberSuccess(state, action) {
    //   state.studiesMember.loading = false;
    //   const updatedMember = action.payload;
    //   const index = state.studiesMember.data.findIndex(
    //     (member) => member.id === updatedMember.id
    //   );
    //   if (index !== -1) {
    //     state.studiesMember.data[index] = updatedMember;
    //   }
    // },
    updateStudiesMemberSuccess(state, action) {
      const updatedMember = action.payload;
      if (!updatedMember?.id) {
        console.error("Updated member does not have an ID:", updatedMember);
        return;
      }
      const index = state.studiesMember.data.findIndex(
        (msg) => msg.id === updatedMember.id
      );
      if (index !== -1) {
        state.studiesMember.data[index] = updatedMember;
      } else {
        console.warn("No matching member found for ID:", updatedMember.id);
      }
    },
    updateStudiesMemberFailure(state, action) {
      state.studiesMember.loading = false;
      state.studiesMember.error = action.payload;
    },
    fetchHistoryStart(state) {
      state.history.loading = true;
      state.history.error = null;
    },
    fetchHistorySuccess(state, action) {
      state.history.loading = false;
      state.history.data = action.payload;
    },
    fetchHistoryFailure(state, action) {
      state.history.loading = false;
      state.history.error = action.payload;
    },
    updateHistoryStart(state) {
      state.history.loading = true;
      state.history.error = null;
    },
    updateHistorySuccess(state, action) {
      state.history.loading = false;
      state.history.data = action.payload;
    },
    updateHistoryFailure(state, action) {
      state.history.loading = false;
      state.history.error = action.payload;
    },
  },
  
});

export const {
  fetchVisionStart,
  fetchVisionSuccess,
  fetchVisionFailure,
  fetchLeadershipMessagesStart,
  fetchLeadershipMessagesSuccess,
  fetchLeadershipMessagesFailure,
  updateLeadershipMessage,
  deleteLeadershipMessage,
  addLeadershipMessageStart,
  addLeadershipMessageSuccess,
  addLeadershipMessageFailure,
  addCouncilMemberStart,
  addCouncilMemberSuccess,
  addCouncilMemberFailure,
  fetchCouncilMemberStart,
  fetchCouncilMemberSuccess,
  fetchCouncilMemberFailure,
  updateCouncilMemberStart,
  updateCouncilMemberSuccess,
  updateCouncilMemberFailure,
  addBoardMemberStart,
  addBoardMemberSuccess,
  addBoardMemberFailure,
  fetchBoardMemberStart,
  fetchBoardMemberSuccess,
  fetchBoardMemberFailure,
  updateBoardMemberStart,
  updateBoardMemberSuccess,
  updateBoardMemberFailure,
  addStudiesMemberStart,
  addStudiesMemberSuccess,
  addStudiesMemberFailure,
  fetchStudiesMemberStart,
  fetchStudiesMemberSuccess,
  fetchStudiesMemberFailure,
  updateStudiesMemberStart,
  updateStudiesMemberSuccess,
  updateStudiesMemberFailure,
  fetchHistoryStart,
  fetchHistorySuccess,
  fetchHistoryFailure,
  updateHistoryStart,
  updateHistorySuccess,
  updateHistoryFailure,


} = aboutUsSlice.actions;

export default aboutUsSlice.reducer;
